<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>各種設定</span>
            </div>
        </div>

        <ul class="list">
            <li class="info">
                <div class="infoLeft">
                    <p>
                        <span class="name">無料配送設定</span>
                        <span class="description">送料の計算に使われます。</span>
                    </p>
                    <p>
                        <span>
                            ￥<input class="inputText" type="text" placeholder="" v-model="config.free_delivery" />
                        </span>
                    </p>
                </div>
                <div class="infoRight">
                </div>
            </li>
            <li class="info">
                <div class="infoLeft">
                    <p>
                        <span class="name">ROAS目標ライン</span>
                        <span class="description">ROASが設定値以下のとき、赤く表示されます。</span>
                    </p>
                    <p>
                        <span>
                            <input class="inputText" type="text" placeholder="" v-model="config.roas_danger" /> %
                        </span>
                    </p>
                </div>
                <div class="infoRight">
                </div>
            </li>
            <li class="info">
                <div class="infoLeft">
                    <p>
                        <span class="name">ROAS達成ライン</span>
                        <span class="description">ROASが設定値以上のとき、青く表示されます。</span>
                    </p>
                    <p>
                        <span>
                            <input class="inputText" type="text" placeholder="" v-model="config.roas_success" /> %
                        </span>
                    </p>
                </div>
                <div class="infoRight">
                </div>
            </li>
        </ul>
        <div class="listFooter">
            <span>
                <a class="btn updateBtn" @click="updateConfig">更新</a>
            </span>
        </div>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    components: {
    },
    data() {
        return {
            statusMessage: "",
            config: {},
        }
    },
    mounted: function () {
        this.$store.dispatch("loading", true);
        this.axios.get("/api/configs")
            .then((res) => {
                this.config = res.data;
                this.$store.dispatch("loading", false);
            }).catch(() => {
            })
    },
    methods: {
        updateConfig: function () {
            this.$store.dispatch("loading", true);
            const data = {
                "free_delivery": this.config.free_delivery,
                "roas_danger": this.config.roas_danger,
                "roas_success": this.config.roas_success
            }
            this.axios.put("/api/configs", data)
                .then(() => {
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        }

    },
    computed: {
    }
}
</script>

<style scoped lang="sass">
.containerInner
    overflow: hidden
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
        .headerRightMenu
            flex: 1 0 auto
            span
                display: inline-block
                text-align: left
                vertical-align: middle
                .addBtn, .adsetUpdateBtn
                    border: 1px solid $mainColor
                    margin-left: 20px
                    padding: 12px
                    width: 170px
                    &:hover
                        border: 1px solid $mainColor
                    span
                        font-size: 0.3rem
    .list
        background: $whiteColor
        font-size: 1.2rem
        margin: 10px 140px 0 140px
        .info
            border-bottom: 3px solid #f8f8ff
            color: $grayColor
            display: flex
            justify-content: space-between
            padding: 10px
            .infoLeft
                display: flex
                flex-direction: column
                justify-content: center
                p
                    margin: 0 0 10px 20px
                    font-size: 1.4rem
                    display: flex
                .name
                    font-weight: 700
                .description
                    margin-left: 16px
                .inputText
                    margin-left: 10px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
            .infoRight
                margin-right: 30px
                display: flex
                flex-direction: column
                justify-content: center
                padding: 10px 0
    .listFooter
        margin: 20px 140px 0 140px
        position: relative
        display: flex
        justify-content: center
        .updateBtn
            width: 80px
    .loadingWindow
        overflow: hidden
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .listHeader
            margin: 20px 0 0 10px
        .list
            margin: 10px 0 0
</style>
